import { IUIStatePrio } from '../../../State/UI/IUIState';
import ITask from '../../../Utility/Task/ITask';
import BaseUISystem from '../BaseUISystem';
import BaseUIHandler from '../BaseUIHandler';

export default class HidePopupPrioTask implements ITask<BaseUISystem> {
    private state: IUIStatePrio;
    private handler: BaseUIHandler;

    constructor(handler: BaseUIHandler, state: IUIStatePrio) {
        this.state = state;
        this.handler = handler;
    }

    public *execute(system: BaseUISystem): IterableIterator<number> {
        yield* this.handler.hidePrio(this.state);
    }
}
